import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useModulesStore } from '@/stores/modules'
import { Clear } from '@mui/icons-material'
import { IconButton } from '@mui/material'

type Props = {
  isLoading?: boolean
}

export function Filters({ isLoading }: Props) {
  const { level, setFilters, clearFilters } = useModulesStore()

  return (
    <section className="text-white mb-6 gap-3 flex flex-wrap items-center">
      {[0, 1, 2, 3, 4].map((index: number) => (
        <Button
          variant="outline"
          disabled={isLoading}
          onClick={() => setFilters(index + 1)}
          key={index + 1}
          className={cn(
            'bg-[#37393F] border-0 hover:shadow-xl hover:ring-0',
            level === index + 1 &&
              'border border-primary text-primary hover:bg-[#37393F] hover:text-primary/60',
          )}
        >
          Nível {index + 1}
        </Button>
      ))}

      {level !== null && (
        <IconButton color="inherit" onClick={clearFilters}>
          <Clear />
        </IconButton>
      )}
    </section>
  )
}
